var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'float-left': _vm.left}},[_c('label',{staticClass:"btn btn-success",class:_vm.labelClass,attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")]),_c('input',{staticClass:"file-input",attrs:{"id":_vm.id,"accept":_vm.accept,"type":"file"},on:{"change":_vm.loadFile,"click":function($event){return _vm.$emit('click')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }